module.exports = __webpack_public_path__ + "eb400be3adeb3130669230ec86b57fff.svg";